import React from 'react'
import Button from '../inputs/button'
import { useLocation, useNavigate } from 'react-router-dom';

function SidebarItem({ title, icon, path }) {
    const location = useLocation();
    const navigate = useNavigate();
    const handleNavigateToPath = () => {
        navigate(path);
    }
    return (
        <li className={`sidebar-item ${location.pathname == path && 'active'}`}>
            <a className='link' onClick={handleNavigateToPath} >
                <span className="icon">{icon}</span>
                <span className='title'>{title}</span>
            </a>
        </li>
    )
}

export default SidebarItem